<template>
  <div class="container container-signin">
    <div class="wrap">
      <input type="radio" name="drawer" id="close-drawer" ref="closeRadio">
      <label class="close" for="close-drawer" v-on:click="clickClose">閉じる</label>
      <div class="signin">
        <section class="detail"><span>ステップ1/3</span>
          <h2>新規登録</h2>
          <p>
             発言やコメントなど、すべての機能をお楽しみいただけます。
            いつでも退会は可能。ともつくネットを楽しみましょう!
          </p>
          <p class="recommend">または
            <label class="login" for="login-drawer">アカウントでログイン</label>
          </p>
          <p class="notice" >アカウントを忘れてしまいましたか？<router-link to="/reissue-password">こちら</router-link>よりお手続きできます。</p>
          <!-- エラーメッセージ表示エリア -->
          <c-validation-errors :errors-hash="errors" ></c-validation-errors>
          <div class="form">
            <div class="group">
              <div class="item">
                <input type="text" placeholder="姓" v-model="lastName"><span class="focusborder"></span>
              </div>
              <div class="item">
                <input type="text" placeholder="名" v-model="firstName"><span class="focusborder"></span>
              </div>
            </div>
            <div class="item">
              <input type="text" placeholder="メールアドレス" v-model="mail"><span class="focusborder"></span>
            </div>
            <div class="item">
              <input type="text" placeholder="ニックネーム" v-model="nickname"><span class="focusborder"></span>
            </div>
            <div class="item submit">
              <input class="button-blue" type="submit" value="仮登録する" @click="saveTemporaryAccount">
            </div>
            <p class="notice">仮登録ボタンを押すと、記入のメールアドレス宛に本登録用のURLをお送りします。</p>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script setup>
import axios from "axios";
import Global from '../../js/constant.js'
import { onMounted, ref, reactive } from "vue"
import { useStore } from 'vuex'
import {useToast} from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import { useRouter } from 'vue-router'

// store取得
const $store = useStore()
const $toast = useToast()
const $router = useRouter()

// --- define state ---
const lastName = ref(null)
const firstName = ref(null)
const nickname = ref(null)
const mail = ref(null)
const errors = reactive({})
const closeRadio = ref(null)

// action操作はdispatch
const save = () => $store.dispatch('save')

// mutation操作はcommit
const setTemporaryAccount = (val) => $store.commit('setTemporaryAccount', val)
const setMail = (val) => $store.commit('setMail', val)
const setClientErrors = (val) => $store.commit('setClientErrors', val)

// --- mounted ---
onMounted(() => {})

// --- methods ---
/**
 * 保存処理
 */
const saveTemporaryAccount = async () => {
  // エラーメッセージを削除
  errors.value = {}

  if (!lastName.value) {
    errors.value['last_name'] = 'REQUIRED_CONSTRAINT_FAILED'
  }
  if (!firstName.value) {
    errors.value['first_name'] = 'REQUIRED_CONSTRAINT_FAILED'
  }
  if (!mail.value) {
    errors.value['mail'] = 'REQUIRED_CONSTRAINT_FAILED'
  }
  if (!nickname.value) {
    errors.value['nickname'] = 'REQUIRED_CONSTRAINT_FAILED'
  }
  if (Object.keys(errors.value).length > 0) {
    $toast.error('error', {position: 'bottom-left'})
    return
  }
  if (!await existsCheck()) {
    lastName.value = null
    firstName.value = null
    mail.value = null
    nickname.value = null
    $toast.error('error', {position: 'bottom-left'})
    errors.value['入力された情報'] = 'ALREADY_EXIST_ERROR'
    return
  }
  let resAccount = await registTemporaryAccount()

  if (resAccount) {
    setMail(mail.value)
    setTemporaryAccount(resAccount)
    save()
    sendMail(resAccount.id)
    closeRadio.value.click()
  }
  return
}
/**
 * 存在チェック
 */
const existsCheck = async () => {
  let params = {
    last_name  : lastName.value,
    first_name : firstName.value,
    mail       : mail.value
    }
  return await axios.post(Global.url.api_accounts_exists, params)
  .then(res => {
    if (res.data.status == Global.api_status.validation_error) {
      errors.value = res.data.errors
      return false
    }
    if (res.data.status == Global.api_status.success) {
      if (res.data.temp_account_exist || res.data.account_exist) {
        return false
      } else {
        return true
      }
    }
  })
  .catch(error=>{
    $toast.error('client error')
    setClientErrors({func:"registration/temporary-sign-in.vue::existsCheck", params: params, errorMessage:error})
  })
}
/**
 * 保存処理
 */
const registTemporaryAccount = async () => {
  let params = {
    last_name : lastName.value,
    first_name : firstName.value,
    mail : mail.value,
    nickname : nickname.value
    }
  return await axios.post(Global.url.api_temp_accounts_create, params)
  .then(res => {
    if (res.data.status == Global.api_status.success) {
      return res.data.account
    }
    if (res.data.status == Global.api_status.validation_error) {
      errors.value = res.data.errors
      return null
    }
    return null
  })
  .catch(error=>{
    $toast.error('client error')
    setClientErrors({func:"registration/temporary-sign-in.vue::registTemporaryAccount", params: params, errorMessage:error})
  })
}
/**
 * メールを送信
 */
const sendMail = (tempAccountId) => {
  let params = {
    account_id : tempAccountId
  }
  axios.post(Global.url.api_accounts_temporary_mail, params)
  .then(res => {
    if (res.data.status == Global.api_status.success) {
      $router.push( { path : `/temporary-sign-in-done/${mail.value}`  }, () => {} )
      return
    }
    if (res.data.status == Global.api_status.validation_error) {
      console.dir(res.data.errors)
      errors.value = res.data.errors
      return
    }
  })
  .catch(error=>{
    $toast.error('client error')
    setClientErrors({func:"registration/temporary-sign-in.vue::sendMail", params: params, errorMessage:error})
  })
}
const clickClose = () => {
  errors.value = {}
  
}
</script>
<!-- <script>
// 仮登録コンポーネント
// 同コンポーネント情報を仮登録し、本登録を促すようメールを送信する
import { mapMutations, mapActions } from 'vuex'

export default {
  components: {},
  data () {
    return {
      lastName : '',
      firstName : '',
      mail : '',
      nickname : '',
      buttonDisabled : false,
      errors: {},
    }
  },
  mounted : function () {

  },
  methods: {
    ...mapMutations([
      'setTemporaryAccount',
      'setMail',
      'setClientErrors',
    ]),      
    ...mapActions([
      'save',
    ]),
    confirmRegistTemporaryAccount : function () {
      // エラーメッセージを削除
      this.errors = {}
      this.existsCheckAndSave()
      // this.registTemporaryAccount()
    },  
    existsCheckAndSave : function () {
      let params = {
        last_name  : this.lastName,
        first_name : this.firstName,
        mail       : this.mail
        }
      this.axios.post(this.Global.url.api_accounts_exists, params)
      .then(res => {
        if (res.data.status == this.Global.api_status.validation_error) {
          this.errors = res.data.errors
          return
        }
        if (res.data.status == this.Global.api_status.success) {
          if (res.data.temp_account_exist || res.data.account_exist) {
            this.lastName = null
            this.firstName = null
            this.$toasted.error('入力された姓名はすでに使用されています')
            return
          }
          this.registTemporaryAccount()
          return
        }

        this.$toasted.error(res.data.exception)
        this.setClientErrors({func:"registration/temporary-sign-in.vue::existsCheckAndSave", params: params, errorMessage:JSON.stringify(res.data)})
      })
      .catch(error=>{
        this.$toasted.error('client error')
        this.setClientErrors({func:"registration/temporary-sign-in.vue::existsCheckAndSave", params: params, errorMessage:error})
      })
    },
    registTemporaryAccount : function () {
      let params = {
        last_name : this.lastName,
        first_name : this.firstName,
        mail : this.mail,
        nickname : this.nickname
        }
      this.axios.post(this.Global.url.api_temp_accounts_create, params)
      .then(res => {
        if (res.data.status == this.Global.api_status.success) {
          this.setMail(this.mail)
          this.setTemporaryAccount(res.data.account)
          this.save()
          this.sendMail(res.data.account.id)
          return
        }
        if (res.data.status == this.Global.api_status.validation_error) {
          this.errors = res.data.errors
          return
        }
        this.$toasted.error(res.data.exception)
        this.setClientErrors({func:"registration/temporary-sign-in.vue::registTemporaryAccount", params: params, errorMessage:JSON.stringify(res.data)})
      })
      .catch(error=>{
        this.$toasted.error('client error')
        this.setClientErrors({func:"registration/temporary-sign-in.vue::registTemporaryAccount", params: params, errorMessage:error})
      })
    },
    sendMail : function (tempAccountId) {
      let params = {
        account_id : tempAccountId
      }
      this.axios.post(this.Global.url.api_accounts_temporary_mail, params)
      .then(res => {
        if (res.data.status == this.Global.api_status.success) {
          this.$router.push( { path : '/temporary-sign-in-done/' + this.mail }, () => {} )
          return
        }
        if (res.data.status == this.Global.api_status.validation_error) {
          console.dir(res.data.errors)
          this.errors = res.data.errors
          return
        }
        this.$toasted.error(res.data.exception)
        this.setClientErrors({func:"registration/temporary-sign-in.vue::sendMail", params: params, errorMessage:JSON.stringify(res.data)})
      })
      .catch(error=>{
        this.$toasted.error('client error')
        this.setClientErrors({func:"registration/temporary-sign-in.vue::sendMail", params: params, errorMessage:error})
      })

    }
  } 
}
</script> -->
